var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "banner-filter" }, [
      _c(
        "div",
        { staticClass: "flex-box hom-content-top pc-warp" },
        [
          _c("cere-classification", {
            attrs: { componentContent: _vm.componentContent }
          }),
          _vm._v(" "),
          _c("BannerSwiper", {
            attrs: {
              componentContent: _vm.componentContent,
              curImageUrl: _vm.curImageUrl
            }
          }),
          _vm._v(" "),
          _c("BannerUserInfo")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-01913521", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-01913521","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/cereshop/pc_b2c/shopHeader.vue
// module id = null
// module chunks = 